import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { certificado } from '../../interfaces/Certificados';
import  { useEffect, useState } from 'react';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import {defaultLayoutPlugin} from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'

//pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface PdfViewerProps {
  pdfBase64: string; 
}

export default function PdfViewer(props: PdfViewerProps){
  const [numPages, setNumPages] = useState<number | null>(null);

  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages);
  }
  const [pageNumber, setPageNumber] = useState(1);

  const pdfContentType: string = 'application/pdf';

const base64toBlob = (data: string): Blob => {
    // Corta el prefijo `data:application/pdf;base64` del base 64 sin formato
    const base64WithoutPrefix: string = data.substr(`data:${pdfContentType};base64,`.length);

    const bytes: string = atob(base64WithoutPrefix);
    let length: number = bytes.length;
    let out: Uint8Array = new Uint8Array(length);

    while (length--) {
        out[length] = bytes.charCodeAt(length);
    }

    return new Blob([out], { type: pdfContentType });
};
const layoutPlugin = defaultLayoutPlugin();
const url: string = URL.createObjectURL(base64toBlob(props.pdfBase64));

  
    return (

      // <Worker
      //       workerUrl='https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js'
      //     >
      //       <Viewer
      //         fileUrl={props.pdfBase64}
      //         plugins={[layoutPlugin]} // Agregar el plugin al visor
      //       />
      //     </Worker>


      //  <div 
      //    >
      //      <Viewer fileUrl={url} />
      //  </div>

      <object
        data={props.pdfBase64}
        type='application/pdf'
        width="80%"
        height="800"
      >

      </object>
      
        
      );

}